// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { success } from 'react-notification-system-redux'
import { loadingToggler } from 'redux/modules/loading'
import { postPerformGroup2CallSignCascade } from 'helpers/api/callsign-cascade'
import updateBulkEditPathsAfterCallsignCascadeSuccess from './updateBulkEditPathsAfterCallsignCascadeSuccess'
import updateProjectDataAfterCallsignCascadeSuccess from './updateProjectDataAfterCallsignCascadeSuccess'
import prepareCascadeUpdateData from './prepareCascadeUpdateData'

/**
 * Takes the Callsign Cascade form's values, determines what segment ends to cascade into, closes the modal then triggers the callback on success
 * @param {object} formValues - object of callsign cascade form values
 * @returns {function(*): *}
 */

const handleCallsignCascadeSubmit = (formValues) => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const withinBulkEdit = getState().pathDetails.get('withinBulkEdit')
      const withinProjectSummary = getState().pathDetails.get('withinProjectSummary')

      const { callsignCascadeInput } = formValues

      // only add to body the aggregate groups for which the user has
      // selected at least one site to cascade down to.
      const cascadeUpdateData = prepareCascadeUpdateData(callsignCascadeInput)

      const triggerCallback = cascadeUpdateData.length !== 0

      // if the user selected no sites to cascade down to,
      // then just get outta here
      if (triggerCallback) {
        const { message } = await postPerformGroup2CallSignCascade(cascadeUpdateData)

        dispatch(success({
          autoDismiss: 5,
          message: (
            <p id={'callsign-cascade-submit-success-notification'}>
              {message}
            </p>
          ),
        }))

        // if we're within project summary, figure out if any of the project's paths need to be updated
        // in redux store
        if (withinProjectSummary) {
          dispatch(updateProjectDataAfterCallsignCascadeSuccess(cascadeUpdateData))
        }

        // if we're within bulk edits, also figure out if any of the bulk edit paths need to be updated
        if (withinBulkEdit) {
          dispatch(updateBulkEditPathsAfterCallsignCascadeSuccess(cascadeUpdateData))
        }
      }

      return triggerCallback
    })
  )
)

export default handleCallsignCascadeSubmit
